module.exports = __webpack_public_path__ + "img/accounting.c8d303fb.svg";